(() => {
  function apply(select,updateUrl) {
    const option=select.selectedOptions[0];
    if(!option)return;
    const id=select.dataset.productId;
    document.querySelectorAll(`[data-fh-product="${id}"]`).forEach(root=>{
      root.querySelectorAll('form[data-fh-atc] input[name="id"]').forEach(input=>{
        input.value=select.value;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      });
      root.querySelectorAll('[data-buy-now]').forEach(button=>{button.dataset.buyNow=select.value;button.disabled=option.dataset.available!=='true'});
      root.querySelectorAll('form[data-fh-atc] button[type="submit"]').forEach(button=>{
        button.disabled=option.dataset.available!=='true';
        const label=button.querySelector('span');
        if(label)label.textContent=option.dataset.available==='true'?'Kosárba':'Elfogyott';
      });
      root.querySelectorAll('.fh-price-now').forEach(price=>price.textContent=option.dataset.price);
      const sticky=root.querySelector('.fh-sticky__price');
      if(sticky&&!sticky.querySelector('s'))sticky.textContent=option.dataset.price;
      root.querySelectorAll('[data-fh-variant]').forEach(other=>other.value=select.value);
      root.querySelectorAll('a[href*="/products/"]').forEach(link=>{
        const url=new URL(link.href,location.origin);
        url.searchParams.set('variant',select.value);
        link.href=url.pathname+url.search+url.hash;
      });
    });
    if(updateUrl&&location.pathname.startsWith('/products/')){
      const url=new URL(location.href);
      url.searchParams.set('variant',select.value);
      history.replaceState({},'',url);
    }
  }
  function boot(root){root.querySelectorAll('[data-fh-variant]').forEach(select=>apply(select,false))}
  document.addEventListener('change',event=>{if(event.target.matches('[data-fh-variant]'))apply(event.target,true)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>boot(document));else boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
